import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

/** Campo de texto longo (Figma FGP: Inputs-large-text — 121px, raio 12, px 8, py 14, Regular 16). */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'h-[121px] w-full resize-none rounded-xl border border-line bg-surface px-2 py-3.5 text-base leading-snug text-ink placeholder:text-placeholder',
        'focus:border-brand-outline focus:outline-none focus:ring-2 focus:ring-brand-100',
        'disabled:cursor-not-allowed disabled:bg-surface-muted',
        className,
        invalid && 'border-flag-danger focus:border-flag-danger focus:ring-red-100',
      )}
      {...props}
    />
  );
});
